import { Observable } from 'rxjs'
import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { EnvironmentsHelperService } from '@environments/core/services/environments-helper.service'
import { CompanyInfoInterface } from '../interfaces/company-info.interface'
import { CompanyStatsInterface } from '../interfaces/company-stats.interface'
import { PriceTargetInterface } from '@modules/twelve-data-module/interfaces/price-target.interface'
import { RecommendationsInterface } from '@modules/twelve-data-module/interfaces/recommendations.interface'

@Injectable()
export class TwelveDataService {
	private readonly _http: HttpClient = inject<HttpClient>(HttpClient)
	private readonly _environmentsHelperService: EnvironmentsHelperService =
		inject<EnvironmentsHelperService>(EnvironmentsHelperService)

	public getCompanyInfo(symbol: string): Observable<CompanyInfoInterface> {
		const params: HttpParams = new HttpParams().set('symbol', symbol)

		return this._http.get<CompanyInfoInterface>(
			`${this._environmentsHelperService.apiUrl}/proxy_api/v1/twelve_data/company_info/`,
			{
				params,
			},
		)
	}

	public getCompanyStats(symbol: string): Observable<CompanyStatsInterface> {
		const params: HttpParams = new HttpParams().set('symbol', symbol)

		return this._http.get<CompanyStatsInterface>(
			`${this._environmentsHelperService.apiUrl}/proxy_api/v1/twelve_data/company_stats/`,
			{
				params,
			},
		)
	}

	public getPriceTarget(symbol: string): Observable<PriceTargetInterface> {
		const params: HttpParams = new HttpParams().set('symbol', symbol)

		return this._http.get<PriceTargetInterface>(
			`${this._environmentsHelperService.apiUrl}/proxy_api/v1/twelve_data/price_target/`,
			{
				params,
			},
		)
	}

	public getRecommendations(symbol: string): Observable<RecommendationsInterface> {
		const params: HttpParams = new HttpParams().set('symbol', symbol)

		return this._http.get<RecommendationsInterface>(
			`${this._environmentsHelperService.apiUrl}/proxy_api/v1/twelve_data/recommendations/`,
			{
				params,
			},
		)
	}
}
